import { Select, Typography } from "antd";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { useConnectionNodes } from "components/common/Pagination";

import type { SsoProviderLoginTypeSelection_idpData$key } from "__generated__/SsoProviderLoginTypeSelection_idpData.graphql";

// TODO (david.taylor): This component uses antd because the only place it's used is stuck on antd (uses a form).
// Once rivet-ui is 1.0 & UserProfile.tsx gets moved to use rivet, we should update this to use rivet as well.

interface SsoProviderLoginTypeSelectionProps {
  onChange: (value: string) => void;
  currentSelection: string;
  idpDataRef: SsoProviderLoginTypeSelection_idpData$key;
  disabled: boolean;
}

export const idpFragment = graphql`
  fragment SsoProviderLoginTypeSelection_idpData on Organization {
    identityProviderConfigurations {
      edges {
        node {
          id
          uuid
          name
          providerType
        }
      }
    }
    loginTypes(orgDefault: true) {
      edges {
        node {
          loginType
          authEnabled
          identityProviderConfiguration {
            id
            uuid
            name
            providerType
          }
        }
      }
    }
  }
`;

const SsoProviderLoginTypeSelection = ({
  onChange,
  currentSelection,
  idpDataRef,
  disabled,
}: SsoProviderLoginTypeSelectionProps) => {
  const idpData = useFragment<SsoProviderLoginTypeSelection_idpData$key>(idpFragment, idpDataRef);
  const idps = useConnectionNodes(idpData.identityProviderConfigurations);

  return (
    <div className="flex">
      <Select
        className="w-40"
        value={currentSelection}
        onChange={onChange}
        disabled={disabled}
        dropdownMatchSelectWidth={false}
      >
        <Select.OptGroup label="Identity Providers">
          {idps.map(
            (
              provider // TODO remove Axon from this this list, since it's in a different thing
            ) => {
              if (provider.providerType === "AXON") {
                return null;
              } else {
                return (
                  <Select.Option key={provider.uuid} value={provider.uuid}>
                    {provider.name} ({provider.providerType})
                  </Select.Option>
                );
              }
            }
          )}
        </Select.OptGroup>
        <Select.Option key="disabled" value="disabled">
          {/* TODO (david.taylor): using antd text for danger type. Move this to rivet once we can change text color */}
          <Typography.Text type="danger">Disabled</Typography.Text>
        </Select.Option>
      </Select>
    </div>
  );
};

export default SsoProviderLoginTypeSelection;
